/* Solvik — calculateur de surface.
   Surcouche progressive : le HTML est déjà complet et utilisable sans ce fichier.
   Aucune dépendance. */

(function () {
  'use strict';

  // Les libelles qui transitent par un attribut `data-` sont echappes deux
  // fois : `| t` echappe le HTML dans le Liquid, puis `textContent` ecrit la
  // chaine telle quelle. « Ma piece n'est pas rectangulaire » ressortait donc
  // en « Ma piece n&#39;est pas rectangulaire ».
  //
  // C'est le quatrieme piege du §35.6, et il ne se voit que sur un libelle qui
  // porte une apostrophe — donc jamais sur celui qu'on teste en premier. On
  // decode une fois, a la lecture. Un `textarea` ne rend actif aucun balisage :
  // c'est le decodage le plus sur du navigateur.
  function decoder(texte) {
    if (!texte) return '';
    var z = document.createElement('textarea');
    z.innerHTML = texte;
    return z.value;
  }


  function arrondiSup(n) {
    // Marge anti-flottant : 8,0000000001 paquets ne doit pas en devenir 9.
    return Math.ceil(n - 1e-9);
  }

  // La formule, sortie de son bloc pour etre partagee.
  //
  // Le Conseiller Sol chiffre le meme projet sur sa page de resultats. Deux
  // implantations de ce calcul divergeraient tot ou tard d'un paquet, et un
  // paquet d'ecart entre la recommandation et la fiche produit, sur un devis
  // a 2 000 €, c'est un appel client. Il n'y a donc qu'un seul endroit ou l'on
  // compte des paquets, et c'est ici.
  //
  // Le budget n'en fait pas partie : il se calcule sur `variant.price`, que
  // l'appelant connait et que cette fonction n'a pas a aller chercher.
  function paquetsPour(surface, surfacePaquet, coefficient) {
    if (!(surface > 0) || !(surfacePaquet > 0) || !(coefficient > 0)) return null;
    var besoin = surface * coefficient;
    var paquets = arrondiSup(besoin / surfacePaquet);
    return { besoin: besoin, paquets: paquets, livre: paquets * surfacePaquet };
  }

  // Lit la surface passee en parametre d'URL. C'est le passage de relais du
  // Conseiller vers la fiche produit : le client a deja donne sa surface, la
  // lui redemander serait lui faire refaire le travail.
  //
  // Liquid ne peut pas lire un parametre d'URL (§12.7), d'ou ce detour par le
  // JS — et comme tout le reste du bloc, ce n'est qu'une surcouche : sans lui,
  // le champ garde sa valeur par defaut et le calculateur fonctionne.
  function surfaceDeLUrl() {
    var m = /[?&]surface=([^&#]+)/.exec(window.location.search);
    if (!m) return null;
    var v = parseFloat(decodeURIComponent(m[1]).replace(',', '.'));
    return (v > 0 && v <= 2000) ? v : null;
  }

  window.SolvikCalcul = {
    arrondiSup: arrondiSup,
    paquets: paquetsPour
  };

  // Reporte la quantité calculée dans le formulaire d'achat : le client n'a
  // plus à traduire lui-même « 25 m² » en « 16 paquets », ni « 18 m » en
  // « 8 plinthes ».
  // Dawn place le champ quantité HORS du formulaire et les relie par
  // l'attribut HTML form. Le chercher à l'intérieur du <form> ne donne rien :
  // il faut interroger tout le document sur cet attribut.
  function champQuantite(bloc) {
    var idForm = bloc.dataset.form;
    if (idForm) {
      var parAttribut = document.querySelector(
        'input[name="quantity"][form="' + idForm + '"]'
      );
      if (parAttribut) return parAttribut;
      var portee = document.getElementById(idForm);
      if (portee) {
        var imbrique = portee.querySelector('input[name="quantity"]');
        if (imbrique) return imbrique;
      }
    }
    return document.querySelector('input[name="quantity"]');
  }

  // Le montant dans le bouton d'ajout.
  //
  // POURQUOI IL EST PILOTE PAR LE CHAMP QUANTITE, ET NON PAR LE CALCULATEUR
  // Le bouton doit annoncer ce que le panier facturera, sinon il ment — et sur
  // un panier a 2 000 EUR, un bouton qui ment est un litige. Or ce que le
  // panier facture, c'est quantite x prix unitaire, rien d'autre. En lisant le
  // champ quantite, le montant est juste PAR CONSTRUCTION, que la quantite
  // vienne du calculateur ou d'une saisie a la main.
  //
  // Le calculateur passe d'ailleurs par ce meme champ (reporterQuantite emet
  // input et change), donc les deux chemins se rejoignent sans se doubler.
  //
  // RIEN AU CHARGEMENT, et c'est voulu. Au premier rendu la quantite vaut 1,
  // alors que le calculateur affiche deja son estimation pour 24 m2 : un bouton
  // a 56,74 EUR a cote d'une reponse a 907,84 EUR se lit comme une
  // contradiction, alors que les deux sont vrais. Le bouton ne parle donc
  // qu'apres un geste du client — la meme regle que « montrer n'est pas
  // engager », qui empeche deja la quantite de bouger toute seule.
  function brancherBouton(bloc) {
    var modele = bloc.dataset.boutonModele;
    // m2 comme metre lineaire : le paquet pour un sol, la piece pour une
    // plinthe. Les deux sont le prix unitaire facture.
    var prixUnite = parseInt(bloc.dataset.prixPaquet || bloc.dataset.prixPiece, 10);
    if (!modele || !(prixUnite > 0)) return;

    var champ = champQuantite(bloc);
    if (!champ) return;

    var idForm = bloc.dataset.form;
    var portee = (idForm && document.getElementById(idForm)) || document;
    var bouton = portee.querySelector('button[name="add"]');
    if (!bouton) return;

    var libelle = bouton.querySelector('span');
    if (!libelle) return;
    var base = libelle.textContent.trim();

    var fmt = formateurs(bloc.dataset.devise || 'EUR');

    function majBouton() {
      var q = parseInt(champ.value, 10);
      // Sans quantite lisible, on retombe sur le libelle nu plutot que
      // d'afficher un montant faux ou un « NaN ».
      if (!(q > 0)) {
        libelle.textContent = base;
        return;
      }
      libelle.textContent = modele
        .replace('{base}', base)
        .replace('{montant}', fmt.argent.format((q * prixUnite) / 100));
    }

    champ.addEventListener('input', majBouton);
    champ.addEventListener('change', majBouton);
  }

  function reporterQuantite(bloc, quantite) {
    if (!quantite) return;
    var entree = champQuantite(bloc);
    if (entree && entree.value !== String(quantite)) {
      entree.value = quantite;
      entree.dispatchEvent(new Event('input', { bubbles: true }));
      entree.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function formateurs(devise) {
    var langue = document.documentElement.lang || 'fr';
    var argent;
    try {
      argent = new Intl.NumberFormat(langue, { style: 'currency', currency: devise });
    } catch (e) {
      argent = { format: function (v) { return v.toFixed(2); } };
    }
    return {
      argent: argent,
      nombre: new Intl.NumberFormat(langue, { maximumFractionDigits: 2 })
    };
  }

  // Calculateur de périmètre, pour les plinthes et profilés vendus au mètre
  // linéaire. Même forme que celui de surface, autre unité : on ne peut pas
  // déduire un périmètre d'une surface — 20 m² peut être 4 × 5 ou 2 × 10 —
  // donc c'est au client de le donner.
  function initialiserPerimetre(bloc) {
    var champ = bloc.querySelector('[data-sv-champ]');
    var reponse = bloc.querySelector('[data-sv-reponse]');
    if (!champ || !reponse) return;

    var longueurPiece = parseFloat(bloc.dataset.longueurPiece);
    var prixPiece = parseInt(bloc.dataset.prixPiece, 10); // centimes
    if (!(longueurPiece > 0) || !(prixPiece >= 0)) return;

    var fmt = formateurs(bloc.dataset.devise || 'EUR');
    var modele = bloc.dataset.modele || '';
    var motUn = bloc.dataset.pieceUn || '1';
    var motN = bloc.dataset.pieceN || '{n}';

    bloc.classList.add('sv-calc--js');
    brancherBouton(bloc);

    function calculer() {
      var saisie = parseFloat(String(champ.value).replace(',', '.'));
      if (!(saisie > 0)) {
        reponse.hidden = true;
        reponse.textContent = '';
        return null;
      }

      var pieces = arrondiSup(saisie / longueurPiece);
      var livre = pieces * longueurPiece;
      var budget = (pieces * prixPiece) / 100;

      var motPieces = pieces === 1 ? motUn : motN.replace('{n}', fmt.nombre.format(pieces));

      reponse.innerHTML = modele
        .replace('{perimetre}', fmt.nombre.format(saisie))
        .replace('{pieces}', motPieces)
        .replace('{livre}', fmt.nombre.format(livre))
        .replace('{budget}', fmt.argent.format(budget));
      reponse.hidden = false;

      return pieces;
    }

    var minuteur;
    champ.addEventListener('input', function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(function () {
        reporterQuantite(bloc, calculer());
      }, 180);
    });
    champ.addEventListener('change', function () {
      reporterQuantite(bloc, calculer());
    });

    // Un premier calcul au chargement, pour que le bloc s'explique de
    // lui-meme : il arrive avec une surface plausible et sa reponse deja
    // ecrite. Rien ne s'affichait auparavant, et comme le champ portait un
    // placeholder grise qui se lit comme une valeur, le calculateur avait
    // l'air casse.
    //
    // On appelle calculer() SANS reporterQuantite : la quantite du panier
    // ne doit pas bouger sur une surface que le client n'a pas saisie.
    // Montrer n'est pas engager. Elle se synchronise des la premiere frappe.
    calculer();
  }

  // Longueur et largeur pilotent le champ de surface, qui reste la source
  // unique du calcul. Deux cotes donnent aussi le perimetre, que solvik-piece-
  // complete ecoute pour composer les plinthes et les profiles.
  //
  // Le champ de surface n'est pas remplace : il est masque tant que les deux
  // cotes suffisent, et reparait pour une piece non rectangulaire. Sans
  // JavaScript, c'est lui qu'on voit — le repli reste entier.
  function initialiserCotes(bloc, champSurface, recalculer, calculerSeul) {
    var longueur = bloc.querySelector('[data-sv-longueur]');
    var largeur = bloc.querySelector('[data-sv-largeur]');
    var blocSurface = bloc.querySelector('[data-sv-bloc-surface]');
    var bascule = bloc.querySelector('[data-sv-bascule-forme]');
    var blocCotes = bloc.querySelector('.sv-calc__saisie--cotes');
    if (!longueur || !largeur || !blocSurface) return;

    // LA SURFACE EST LE MODE PAR DEFAUT (2026-09-09).
    //
    // C'est la question que le client se pose — « j'ai 24 m2 » — et celle a
    // laquelle il repond sans se lever. Les deux cotes sont l'affinage : ils
    // servent a ceux qui n'ont pas encore mesure, et surtout ils donnent le
    // PERIMETRE, que le pack utilise pour compter les plinthes.
    var blocCotes = bloc.querySelector('.sv-calc__saisie--cotes');
    var parCotes = false;
    blocSurface.hidden = false;
    if (blocCotes) blocCotes.hidden = true;

    // Le libelle du bouton suit le mode. Fige, il aurait continue de proposer
    // « mesurer par la largeur et la longueur » alors qu'on y etait deja.
    var motCotes = decoder(bloc.dataset.modeCotes);
    var motSurface = decoder(bloc.dataset.modeSurface);
    function majLibelle() {
      if (!bascule || !motCotes || !motSurface) return;
      bascule.textContent = parCotes ? motSurface : motCotes;
    }

    function lire(champ) {
      return parseFloat(String(champ.value).replace(',', '.'));
    }

    // `reporter` a false au chargement : on MONTRE le calcul sans TOUCHER a la
    // quantite du panier.
    //
    // La regle etait deja ecrite plus bas — « montrer n'est pas engager » — mais
    // la saisie par cotes, ajoutee ensuite, la contournait : son `appliquer()`
    // de fin d'initialisation appelait `recalculer()`, donc `reporterQuantite`,
    // et la page arrivait avec 9 paquets deja engages pour une piece de 6 x 4 m
    // que personne n'avait donnee.
    //
    // Sans consequence visible tant que la quantite dormait dans un petit
    // champ. Depuis que le bouton porte le montant (2026-09-09), la page
    // arrivait en annoncant « Ajouter au panier · 1 247,40 € » pour une surface
    // d'illustration — et un client presse qui clique commande pour 24 m2 au
    // lieu de sa chambre de 12. Un retour coute les frais de port au client :
    // c'est la mauvaise surprise qu'on passe la journee a eviter.
    function appliquer(reporter) {
      var L = lire(longueur);
      var l = lire(largeur);
      if (!(L > 0) || !(l > 0)) return;

      // Arrondi au centieme : 6 x 4,1 ne doit pas rendre 24,599999999999998.
      champSurface.value = String(Math.round(L * l * 100) / 100);
      if (reporter === false) {
        calculerSeul();
      } else {
        recalculer();
      }
      publierPiece(bloc, L * l, 2 * (L + l), L, l);
    }

    [longueur, largeur].forEach(function (champ) {
      champ.addEventListener('input', appliquer);
      champ.addEventListener('change', appliquer);
    });

    if (bascule) {
      majLibelle();
      bascule.addEventListener('click', function () {
        parCotes = !parCotes;
        blocSurface.hidden = parCotes;
        if (blocCotes) blocCotes.hidden = !parCotes;
        majLibelle();
        if (parCotes) {
          appliquer();
        } else {
          // Sans les deux cotes, aucun perimetre n'est connu : on le dit
          // plutot que d'en inventer un depuis la surface (§11.4).
          recalculer();
          publierPiece(bloc, lire(champSurface), null);
        }
      });
    }

    // AU CHARGEMENT, LA QUANTITE SUIT LA SURFACE AFFICHEE — et cette decision
    // a ete prise, puis defaite, puis reprise le meme jour. Le detour vaut
    // d'etre ecrit.
    //
    // Elle a d'abord ete retiree : la saisie par cotes engageait 9 paquets pour
    // une piece de 6 x 4 m que personne n'avait donnee, et le bouton, une fois
    // qu'il a porte le montant, annoncait 1 247 EUR pour une surface
    // d'illustration. Le grief etait juste, mais il portait sur l'INVISIBILITE
    // de la valeur : le champ de surface etait masque, et 24 m2 sortait d'un
    // 6 x 4 que le client ne voyait pas.
    //
    // Depuis que la surface est le mode par defaut, ce champ est le premier
    // qu'on lit, il porte 24 en clair, et le calculateur ecrit « Pour 24 m2 »
    // juste en dessous. Une quantite qui suit un nombre affiche et modifiable
    // n'est plus un piege : c'est une valeur par defaut.
    //
    // Et ne pas la reporter creait pire. Le pack lit la quantite du panier pour
    // sa ligne « sol » (voir solvik-piece-complete.js, et la raison y est
    // bonne : deux formules pour un meme nombre finissent par diverger) tandis
    // que la sous-couche suit la surface. La page arrivait donc en chiffrant un
    // sol de 1 paquet et une sous-couche de 24 m2, dans le meme tableau.
    recalculer();
    publierPiece(bloc, lire(champSurface), null);
  }

  // Un evenement plutot qu'un appel direct : le calculateur n'a pas a savoir
  // qui l'ecoute, et la page reste utilisable si le bloc « piece complete »
  // n'est pas rendu.
  // `longueur` et `largeur` voyagent avec la surface et le perimetre : le pack
  // porte desormais ses propres champs de dimensions, et il doit pouvoir les
  // pre-remplir quand le client a deja repondu ici. Sans elles, il faudrait les
  // deduire de la surface et du perimetre — deux racines d'une equation du
  // second degre pour retrouver ce qu'on avait sous la main.
  function publierPiece(bloc, surface, perimetre, longueur, largeur) {
    var detail = {
      surface: surface,
      perimetre: perimetre,
      longueur: longueur || null,
      largeur: largeur || null
    };

    // La derniere valeur est aussi deposee sur window, et pas seulement
    // diffusee. Les deux scripts sont charges en `defer` : celui-ci s'execute
    // en premier et publiait donc AVANT que la piece complete n'ait pose son
    // ecouteur. Le premier calcul etait perdu, et les plinthes restaient a
    // « — » jusqu'a ce que le client touche un champ.
    //
    // Un etat lisible a tout moment supprime la course, sans imposer un ordre
    // de chargement entre deux fichiers qui n'ont pas a se connaitre.
    window.solvikPiece = detail;

    bloc.dispatchEvent(new CustomEvent('solvik:piece', {
      bubbles: true,
      detail: detail
    }));
  }

  function initialiser(bloc) {
    var champ = bloc.querySelector('[data-sv-champ]');
    var reponse = bloc.querySelector('[data-sv-reponse]');
    if (!champ || !reponse) return;

    var surfacePaquet = parseFloat(bloc.dataset.surfacePaquet);
    var prixPaquet = parseInt(bloc.dataset.prixPaquet, 10); // centimes
    var coefficient = parseFloat(bloc.dataset.coefficient);
    if (!(surfacePaquet > 0) || !(prixPaquet >= 0) || !(coefficient > 0)) return;

    var devise = bloc.dataset.devise || 'EUR';
    var langue = document.documentElement.lang || 'fr';
    var modele = bloc.dataset.modele || '';
    var motPaquetUn = bloc.dataset.paquetUn || '1';
    var motPaquetN = bloc.dataset.paquetN || '{n}';

    // Le minimum de commande. Le Liquid a déjà écrit le seuil en mètres carrés
    // juste en dessous ; ce qu'on ajoute ici est le seul chiffre qu'il ne
    // pouvait pas connaître : ce qui manque à CETTE surface.
    var minimum = parseFloat(bloc.dataset.minimum);
    var noteMinimum = bloc.querySelector('[data-sv-minimum]');
    var modeleMinimum = bloc.dataset.minimumModele || '';
    // Retirée de la fiche le 2026-09-18 ; les usages plus bas testent null.
    var annoncePack = bloc.querySelector('[data-sv-annonce-pack]');
    // L'invitation du champ vide (2026-09-28) : elle parle tant qu'il n'y a
    // pas de surface, et se tait des qu'il y en a une.
    var invite = bloc.querySelector('[data-sv-invite]');

    var argent;
    try {
      argent = new Intl.NumberFormat(langue, { style: 'currency', currency: devise });
    } catch (e) {
      argent = { format: function (v) { return v.toFixed(2); } };
    }
    var nombre = new Intl.NumberFormat(langue, { maximumFractionDigits: 2 });

    bloc.classList.add('sv-calc--js');
    brancherBouton(bloc);

    // Le client vient du Conseiller : sa surface est dans l'URL. On la pose
    // avant le premier calcul, pour que la reponse affichee soit la sienne.
    var imposee = surfaceDeLUrl();
    if (imposee) champ.value = String(imposee);

    function calculer() {
      var saisie = parseFloat(String(champ.value).replace(',', '.'));
      if (!(saisie > 0)) {
        reponse.hidden = true;
        reponse.textContent = '';
        // Sans surface, pas de manque : laisser le message précédent affiché
        // le ferait porter sur un chiffre qui n'est plus à l'écran.
        if (noteMinimum) {
          noteMinimum.hidden = true;
        }
        // Idem pour l'annonce du pack : « pour cette surface » ne veut rien
        // dire sans surface.
        if (annoncePack) annoncePack.hidden = true;
        if (invite) invite.hidden = false;
        return null;
      }
      if (invite) invite.hidden = true;

      var compte = paquetsPour(saisie, surfacePaquet, coefficient);
      if (!compte) {
        reponse.hidden = true;
        reponse.textContent = '';
        return null;
      }
      var paquets = compte.paquets;
      var livre = compte.livre;
      var budget = (paquets * prixPaquet) / 100;

      var motPaquets = paquets === 1
        ? motPaquetUn
        : motPaquetN.replace('{n}', nombre.format(paquets));

      reponse.innerHTML = modele
        .replace('{surface}', nombre.format(saisie))
        .replace('{paquets}', motPaquets)
        .replace('{livre}', nombre.format(livre))
        .replace('{budget}', argent.format(budget));
      reponse.hidden = false;

      if (annoncePack) annoncePack.hidden = false;

      annoncerMinimum(budget);

      return paquets;
    }

    // Muet quand le budget passe le seuil : une alerte permanente n'alerte de
    // rien. Le sol seul est comparé au minimum, alors que la sous-couche et
    // les plinthes comptent aussi — le message le dit, et le manque annoncé
    // est donc un majorant. Se tromper dans ce sens-là fait ajouter un
    // accessoire de trop, jamais découvrir un mur au paiement.
    // LE PARAGRAPHE N'EST JAMAIS ECRIT NI VIDE EN ENTIER.
    //
    // Il porte deux choses : le manque, ecrit ici, et la porte de sortie
    // (« ecrivez-nous, on la joint a une expedition prevue »), rendue par le
    // serveur. Toucher a `noteMinimum.textContent` emporte la seconde.
    //
    // C'est arrive : le premier calcul d'une page se fait au chargement avec
    // 24 m2, donc au-dessus du minimum, donc par la branche d'effacement — qui
    // vidait le <p> avant que quiconque ait rien vu. La porte de sortie avait
    // disparu de toutes les fiches sans qu'aucun test ne la cherche au bon
    // moment. On ne vide donc que le span du manque.
    function annoncerMinimum(budget) {
      if (!noteMinimum || !modeleMinimum || !(minimum > 0)) return;

      var cible = noteMinimum.querySelector('[data-sv-minimum-texte]') || noteMinimum;

      if (budget >= minimum) {
        noteMinimum.hidden = true;
        cible.textContent = '';
        return;
      }

      cible.textContent = modeleMinimum
        .replace('{montant}', argent.format(minimum))
        .replace('{manque}', argent.format(minimum - budget));
      noteMinimum.hidden = false;
    }

    // LA SURFACE TAPEE A LA MAIN N'ATTEIGNAIT PAS LE PACK (relevé le
    // 2026-09-28). Seuls le chargement et la saisie par cotes publiaient
    // `solvik:piece` : un client qui tapait 40 m2 voyait sa sous-couche
    // rester comptee sur les 24 m2 affiches au chargement. Invisible tant que
    // le champ arrivait rempli ; flagrant depuis qu'il arrive vide.
    // Perimetre nul : une surface ne le donne pas, et le pack garde celui de
    // ses propres dimensions s'il en a (voir « qui fait autorite »).
    function publierSurface() {
      publierPiece(bloc, parseFloat(String(champ.value).replace(',', '.')), null);
    }

    var minuteur;
    champ.addEventListener('input', function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(function () {
        reporterQuantite(bloc, calculer());
        publierSurface();
      }, 180);
    });

    champ.addEventListener('change', function () {
      reporterQuantite(bloc, calculer());
      publierSurface();
    });

    // Un premier calcul au chargement, pour que le bloc s'explique de
    // lui-meme : il arrive avec une surface plausible et sa reponse deja
    // ecrite. Rien ne s'affichait auparavant, et comme le champ portait un
    // placeholder grise qui se lit comme une valeur, le calculateur avait
    // l'air casse.
    //
    // On appelle calculer() SANS reporterQuantite : la quantite du panier
    // ne doit pas bouger sur une surface que le client n'a pas saisie.
    // Montrer n'est pas engager. Elle se synchronise des la premiere frappe.
    calculer();

    // La saisie par cotes se branche apres coup : elle pilote le meme champ de
    // surface et redemande le meme calcul.
    initialiserCotes(
      bloc,
      champ,
      function () {
        reporterQuantite(bloc, calculer());
      },
      calculer
    );
  }

  function demarrer() {
    document.querySelectorAll('[data-sv-calc]').forEach(initialiser);
    document.querySelectorAll('[data-sv-perimetre]').forEach(initialiserPerimetre);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
